import axios from "@/utils/axios";
const API_URL = process.env.VUE_APP_API_URL || "";

export const getWarehouseData = async () => {
  const response = await axios.get(`${API_URL}/entrepots`);
  return response.data.data;
};

export const getWarehouseDataByID = async (id) => {
  const response = await axios.get(`${API_URL}/entrepots/${id}`);
  return response.data;
};

export const createWarehouse = async (data) => {
  const response = await axios.post(`${API_URL}/entrepots`, data);
  return response.data.data;
};

export const updateWarehouse = async (id, data) => {
  const response = await axios.put(`${API_URL}/entrepots/${id}`, data);
  return response.data.data;
};

export const deleteWarehouse = async (id) => {
  const response = await axios.delete(`${API_URL}/entrepots/${id}`);

  return response.data;
};

export const getProductsData = async () => {
  const response = await axios.get(`${API_URL}/produits`);

  return response.data.data;
};

export const getProductsDataInStock = async () => {
  const response = await axios.get(`${API_URL}/produits/en-stock`);

  return response.data.data;
};

export const getProductsDataWithStock = async () => {
  // Includes all products with aggregated stock info (even when total is 0)
  const response = await axios.get(`${API_URL}/produits/avec-stock`);
  return response.data.data;
};

export const createProduct = async (data) => {
  const response = await axios.post(`${API_URL}/produits`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await axios.delete(`${API_URL}/produits/${id}`);
  return response.data;
};

export const updateProduct = async (id, data) => {
  if (data instanceof FormData) {
    if (data.has("_method")) {
      data.delete("_method");
    }
    data.append("_method", "PUT");
    const response = await axios.post(`${API_URL}/produits/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }
  const response = await axios.put(`${API_URL}/produits/${id}`, data);
  return response.data;
};

export const getProductUnitSales = async (params = {}) => {
  const response = await axios.get(`${API_URL}/ventes-unitaires`, {
    params,
  });
  const payload = response && response.data ? response.data.data : null;
  if (payload) {
    return payload;
  }
  return {
    sales: [],
    products: [],
    users: [],
  };
};

export const createProductUnitSale = async (data) => {
  const response = await axios.post(`${API_URL}/ventes-unitaires`, data);
  return response.data;
};

export const updateProductUnitSale = async (id, data) => {
  const response = await axios.put(`${API_URL}/ventes-unitaires/${id}`, data);
  return response.data;
};

export const deleteProductUnitSale = async (id) => {
  const response = await axios.delete(`${API_URL}/ventes-unitaires/${id}`);
  return response.data;
};

export const getCategoriesData = async () => {
  const response = await axios.get(`${API_URL}/service-categories`);
  return response.data.data;
};

export const createCategory = async (data) => {
  const response = await axios.post(`${API_URL}/service-categories`, data);
  return response.data.data;
};

export const deleteCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/service-categories/${id}`);
  return response.data.data;
};

export const updateCategory = async (id, data) => {
  const response = await axios.put(`${API_URL}/service-categories/${id}`, data);
  return response.data.data;
};

export const getServicesData = async () => {
  const response = await axios.get(`${API_URL}/services`);
  return response.data.data;
};

export const createService = async (data) => {
  const response = await axios.post(`${API_URL}/services`, data);
  return response.data.data;
};

export const deleteService = async (id) => {
  const response = await axios.delete(`${API_URL}/services/${id}`);
  return response.data;
};

export const updateService = async (id, data) => {
  const response = await axios.put(`${API_URL}/services/${id}`, data);
  return response.data.data;
};
